import React from "react";
import { Link } from "react-router-dom";
import CoverImage from "../../assets/home.jpg";

function Home() {
  document.title = "Home - To Do App";
  
  return (
    <div className="home">
      <div className="content">
        <h1>You have a lot going on, and you forgot things to do ?</h1>
        <p>
          Mange your life with ToDo app. When you're overwhelmed by the amount
          of things you need to do, you need a todo app to help you remember
          things.
        </p>
        <Link to={`/todos`}> Try our ToDo app</Link>
      </div>
      <div className="image">
        <img src={CoverImage} alt="home" />
      </div>
    </div>
  );
}

export default Home;
